<template>
  <div class="flex flex-col space-y-6 sm:flex-row sm:space-y-0 sm:space-x-6">
    <div class="space-y-12">
      <div class="space-y-6">
        <img
          :src="data.contest_image"
          :alt="data.contest_name"
          class="mb-12 w-[700px] rounded-lg shadow-lg"
        />
        <div class="flex items-center space-x-4">
          <i v-html="$icons.check_circle" class="text-ontick-green-600"></i>

          <h2 class="text-2xl font-bold sm:text-4xl">Inscrição confirmada!</h2>
        </div>
        <div>
          <h3 class="pb-4 text-lg font-bold">Agenda</h3>
          <ul class="space-y-2 pl-5">
            <li
              v-for="(item, index) in data.contest_agenda"
              :key="index"
              class="list-disc"
            >
              <p class="text-gray-500 dark:text-gray-400">
                {{ item }}
              </p>
            </li>
          </ul>
        </div>
        <div>
          <h3 class="pb-4 text-lg font-bold">Regras</h3>
          <ul class="space-y-2 pl-5">
            <li
              v-for="(item, index) in data.contest_rules"
              :key="index"
              class="list-disc"
            >
              <p class="text-gray-500 dark:text-gray-400">
                {{ item }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <ontick-button @click.native="changeAccount">
        Ir para campeonato
      </ontick-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },

  methods: {
    changeAccount() {
      this.$emit("changeAccount");
    },
  },

  created() {
    this.$emit("getConfig");
  },
};
</script>

<style lang="scss" scoped></style>
